import axios from 'axios';

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:5000/api';

const api = axios.create({
  baseURL: `${API_URL}/notifications`,
  headers: { 'Content-Type': 'application/json' },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('accessToken');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

const notificationPreferencesService = {
  getPreferences: async () => (await api.get('/preferences')).data,
  updatePreferences: async (data) => (await api.put('/preferences', data)).data,
};

export default notificationPreferencesService;



